<template lang="pug">
	.company-info-checker
		Popup(v-if="popupTimeZone", :popupVisible="popupTimeZone", :width="420", :height="280")
			.flex-col.space-medium(:class="{ 'disabled-controls': isLoading }")
				span {{$tCaption('Your company has no default time zone, so creative will be created in UTC time zone. You can choose your company\'s time zone in a dropdown below.')}}
				.flex-col
					.font-small.grey.upper {{$tCaption('Time zone')}}
					Dropdown(
						:getTotal="(data) => data.TotalNumberOfRecords",
						:getItems="(data) => data.Results",
						:getData="$Data.getTimeZones",
						:columns="[{ dataField: 'DisplayName', caption: $tCaption('Time zone') }]",
						displayExpr="DisplayName",
						valueExpr="Id",
						:selectedItems="timeZoneId",
						:showColumnHeaders="false",
						:filtersVisible="false",
						:searchVisible="true",
						:multiple="false",
						:minSearchLength="0",
						@select-data="item => timeZoneId = item ? item.Id : null"
					)
			template(slot="actions-right")
				DxButton(:text="$tCaption('Skip', '@actions')", @click="popupTimeZone = false; resolveTimeZone();", :disabled="!!isLoading")
				DxButton(:text="$tCaption('Update timezone', '@actions')", :disabled="!timeZoneId || !!isLoading", @click="saveTimeZone", type="success")
</template>

<script>
	import Loader from 'app-core/Loader.vue';
	import VueTypes from 'vue-types';
	import DxButton from 'devextreme-vue/button';
	import Popup from 'app-core/Popup.vue';
	import Dropdown from 'app-core/Dropdown.vue';

	export default {
		translationCategory: 'company.CompanyInfoChecker',
		components: { DxButton, Loader, Popup, Dropdown },
		name: 'company-info-checker',
		props: {
			defaultCheckTimeZones: VueTypes.bool.def(false)
		},
		data() {
			return {
				popupTimeZone: false,
				timeZoneId: null,
				isLoading: false
			}
		},
		computed: {
		},
		mounted() {
			if (this.defaultCheckTimeZones) {
				this.checkTimeZones();
			}
		},
		methods: {
			checkTimeZones() {
				return new Promise(res => {
					if (!this.$auth.company().TimeZoneId) {
						if (this.$auth.isDirector()) {
							this.$timeZonePromiseResolve = res;
							this.popupTimeZone = false;
							this.timeZoneId = null;
							setImmediate(() => this.popupTimeZone = true);
						} else {
							this.$notifyWarning(this.$tCaption('Your company has no default time zone, so creative was created in UTC time zone. Recommend you to set the default time zone in your company\'s account'));
							res();
						}
					} else {
						res();
					}
				});
			},
			async saveTimeZone() {
				this.isLoading++;
				try {		
					const company = await this.$Data.getExternalApi('Company/GetCompany', `companyId=${this.$auth.company().Oid}`);
					company.TimeZoneId = this.timeZoneId;
					this.$auth.company().TimeZoneId = this.timeZoneId;
					await this.$Data.postExternalApi('Company/CreateUpdateCompany', company);
					this.popupTimeZone = false;
				} finally {
					this.resolveTimeZone();
					this.isLoading--;
				}
			},
			resolveTimeZone() {
				if (this.$timeZonePromiseResolve)
					this.$timeZonePromiseResolve();
				delete this.$timeZonePromiseResolve;
			}
		}
	};
</script>
<style lang='scss'>
	.company-info-checker {
		
	}
</style>
 